<script setup lang="ts">
const route = useRoute()
const { locale }  = useI18n()

const runtimeConfig = useRuntimeConfig()

const previewSecret = runtimeConfig?.previewSecret || runtimeConfig?.public?.previewSecret
const isPreview = computed(() => route?.query?.previewSecret === previewSecret)

const { data, error } = await useAsyncData<HomePage>(
  () => `home-page-${locale.value}`,
  () => {
    const query = GlobalHomePageQuery
    return $fetch<HomePage>('/api/payload-gql', {
      method: 'POST',
      body: {
        query,
        variables: {
          locale: locale.value,
          isPreview: isPreview.value,
        },
        isPreview: isPreview.value,
      },
    })
  }
)

if (error.value) {
  throw createError({
    statusCode: 500,
    statusMessage: `Error fetching page`,
  })
}
</script>

<template>
  <page-layout> 
    <template #header>
      <page-header 
        class="!fixed !right-0"
        :controls-only="true"
      />
    </template>

    <template #default>
      <pages-home
        v-if="data"
        :data="data"
      />
    </template>
  </page-layout>
</template>
